import React from 'react';
import path from 'path';
import firebase from '../Firebase'
import { DEFAULT_FFILE_SCALING, USE_SCREENS_FROM_WARROOM } from '../Config';
import { requestWarroomServerPost } from '../actions';
import APIManager from '../managers/APIManager';

class DataHelper extends React.Component {

    static logoutInProgress = false;
    static nextSessionOverMessage = null;
    static checkIsVideo = (fileName) => {
        const videoExtensions = ["mp4", "avi", "mov"];
        const ext = path.extname(fileName).toLocaleLowerCase().replace(".", "")

        return videoExtensions.some((extName) => {
            return ext === extName.toLocaleLowerCase()
        });
    }

    static prepareFileData = (filedata) => {
        const type = DataHelper.checkIsVideo(filedata.UploadFile) ? "video" : "image"
        filedata.type = type
        return filedata
    }

    static getTrashFiles = (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {
            requestServerGet("get_file_trashs", params, null, (response) => {
                // console.log("get_files" + JSON.stringify(response.data))

                const prepairedData = response.data.map(data => {
                    return DataHelper.prepareFileData(data)
                })

                resolve(prepairedData)
            }, usertoken)
        });
    }

    static getBranches = (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {
            requestServerGet("get_branches", params, null, (response) => {
                // console.log("get_files" + JSON.stringify(response.data))

                const prepairedData = response.data.map(data => {
                    return DataHelper.prepareFileData(data)
                })

                resolve(prepairedData)
            }, usertoken)
        });
    }

    static getFiles = (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {
            requestServerGet("get_files", params, null, (response) => {
                // requestServerGet("get_files_with_conversion", params, null, (response) => {
                // console.log("get_files" + JSON.stringify(response.data))

                const prepairedData = response.data.map(data => {
                    return DataHelper.prepareFileData(data)
                })

                resolve(prepairedData)
            }, usertoken)
        });
    }
    static getFolderFiles = async (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {
            requestServerGet("get_folderfile", params, null, (response) => {
                // requestServerGet("get_files_with_conversion", params, null, (response) => {
                console.log("get_folderfiles" + JSON.stringify(response.data))

                // const prepairedData = response.data.map(data => {
                //     return DataHelper.prepareFileData(data)
                // })

                resolve(response.data)
            }, usertoken)
        });
    }

    static updateFile = async (params, props) => {
        const { usertoken, requestServerPost, selectedBrandData } = props
        return new Promise((resolve, reject) => {
            requestServerPost("update_file", { ...params, brandid: selectedBrandData.BrandID }, {}, (response) => {
                console.log("update_file" + JSON.stringify(response.data))

                resolve(response.data)
            }, usertoken);
        })
    }

    static updateFolderFile = async (params, props, accessbranchesOverride = null) => {
        const { usertoken, requestServerPost, selectedBrandData } = props
        const finalParams = { ...params, brandid: selectedBrandData.BrandID };
        if (accessbranchesOverride !== null) {
            finalParams.accessbranches = accessbranchesOverride;
        }
        return new Promise((resolve, reject) => {
            requestServerPost("update_folderfile", finalParams, {}, (response) => {
                resolve(response.data)
            }, usertoken);
        })
    }
    static deleteFolderFile = async (params, props) => {
        const { usertoken, requestServerPost, selectedBrandData } = props
        return new Promise((resolve, reject) => {
            requestServerPost("delete_folderfile", { ...params, brandid: selectedBrandData.BrandID }, {}, (response) => {
                console.log("delete_folderfile" + JSON.stringify(response.data))

                resolve(response.data)
            }, usertoken);
        })
    }

    static getFileConversionTasks = (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {
            requestServerGet("get_fileconversiontasks", params, null, (response) => {
                // console.log("get_files" + JSON.stringify(response.data))

                const prepairedData = response.data.map(data => {
                    return DataHelper.prepareFileData(data)
                })

                resolve(prepairedData)
            }, usertoken)
        });
    }
    static getWidgetInstances = (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {
            requestServerGet("get_widget_instances", params, null, (response) => {
                // console.log("get_files" + JSON.stringify(response.data))

                resolve(response.data)
            }, usertoken)
        });
    }

    static getCaseInsensitiveFromObject(obj, key) {
        const foundKey = Object.keys(obj).find(k => k.toLowerCase() === key.toLowerCase());
        return foundKey ? obj[foundKey] : undefined;
    }

    static getScreensUsage(licenses, mode = "separate") {
        if (mode === "sum") {
            // Sum across all licenses
            let totalUsed = 0;
            let totalAvailable = 0;

            licenses.forEach(license => {
                totalUsed += license.screens_use ? license.screens_use.length : 0;
                totalAvailable += license.license_total ?? 0;
            });

            return {
                usedScreens: totalUsed,
                totalScreens: totalAvailable,
                remainingScreens: totalAvailable - totalUsed
            };
        }

        // Default: separate per license
        return licenses.map(license => {
            const used = license.screens_use ? license.screens_use.length : 0;
            const total = license.license_total ?? 0;

            return {
                licenseId: license.id,
                usedScreens: used,
                totalScreens: total,
                remainingScreens: total - used
            };
        });
    }

    //warroom APIs
    static getScreensWithWarroom = (params, props) => {
        const { usertoken } = props
        return new Promise((resolve, reject) => {


            APIManager.requestWarroomServerPost("get_screens", { ...params, old_token: usertoken }, null).then((response) => {

                const screensData = response;
                resolve(screensData)
            }, usertoken)
        });
    }



    static getScreenWithoutWarroom = (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {

            requestServerGet("get_screens", params, null, (response) => {

                const screensData = response.data

                resolve(screensData)
            }, usertoken)
        });
    }

    static getScreens = (params, props) => {
        return USE_SCREENS_FROM_WARROOM ? DataHelper.getScreensWithWarroom(params, props) : DataHelper.getScreenWithoutWarroom(params, props);
    }

    static getScreensByPlaylist = (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {

            requestServerGet("get_screensbyplaylist", params, null, (response) => {

                const screensData = response.data

                resolve(screensData)
            }, usertoken)
        });
    }

    //for multiple files upload
    // static handleFilesUpload = (
    //     files,
    //     props,
    //     uploadProgressUpdate = () => { },
    //     onProgress = () => { },
    //     currentProgress = 0
    // ) => {
    //     return new Promise((resolve, reject) => {
    //         const { requestFilesServerPost, usertoken, selectedBrandData } = props;

    //         const promises = [];

    //         const fileTypes = files.map(file => file?.filetype || file?.type || "unknown");
    //         const fileproperties = files.map(file => file?.properties ? JSON.stringify(file.properties) : "");

    //         const params = new FormData();

    //         files.forEach((file, index) => {
    //             params.append('file[]', file);
    //         });

    //         fileTypes.forEach(type => params.append('filetypes[]', type));
    //         fileproperties.forEach(prop => params.append('fileproperties[]', prop));
    //         params.append('brandid', selectedBrandData.BrandID);

    //         files.forEach(file => {
    //             file.progress = currentProgress;
    //             uploadProgressUpdate(file);
    //         });

    //         const config = {
    //             onUploadProgress: (progressEvent) => {
    //                 const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

    //                 files.forEach((file, index) => {
    //                     const percentPerSection = 100 / files.length;
    //                     const sectionProgress = percentCompleted >= percentPerSection * (index + 1)
    //                         ? 100
    //                         : ((percentCompleted - percentPerSection * index) * 100) / percentPerSection;

    //                     file.progress = Math.max(0, Math.min(100, sectionProgress));
    //                     uploadProgressUpdate(file, sectionProgress);
    //                     onProgress({ uploadProgress: percentCompleted });
    //                 });
    //             }
    //         };

    //         promises.push(new Promise((resolveInner, rejectInner) => {
    //             requestFilesServerPost(
    //                 "create_files_with_conversion",
    //                 params,
    //                 { 'Content-Type': 'multipart/form-data' },
    //                 (response) => {
    //                     console.log("Upload response:", response);
    //                     resolveInner();
    //                 },
    //                 usertoken,
    //                 config
    //             );
    //         }));

    //         return Promise.all(promises).then(resolve).catch(reject);
    //     });
    // }


    static handleFilesUpload = (files, props, uploadProgressUpdate = () => { }, onProgress = () => { }, currentProgress = 0, accessbranchesOverride = null) => {
        const { requestFilesServerPost, usertoken, selectedBrandData, selectedBranchData, selectedFolderID } = props;

        const promises = [];

        // Determine create level and accessbranches based on ContentSharingMode
        const sharingMode = selectedBrandData ? selectedBrandData.ContentSharingMode : null;
        let createlevel = 1;
        let accessbranches = "all";

        if (sharingMode == 2) {
            const isBrandLevel = !selectedBranchData;
            createlevel = isBrandLevel ? 1 : 2;
            accessbranches = isBrandLevel ? "all" : selectedBranchData.BranchID;
        }

        if (accessbranchesOverride !== null) {
            accessbranches = accessbranchesOverride;
        }

        files.forEach((file) => {
            var params = new FormData();
            params.append('file[]', file);
            params.append('filetype', file.filetype);
            params.append('brandid', selectedBrandData.BrandID);
            params.append('fileproperties', JSON.stringify(file.properties));
            params.append('folderparentid', selectedFolderID);
            params.append('createlevel', createlevel);
            params.append('accessbranches', accessbranches);

            file.progress = currentProgress;
            uploadProgressUpdate(file);

            // Track last reported percent, throttle, and completion state
            let lastReportedPercent = -1;
            let lastCallTime = 0;
            let isCompleted = false;
            const THROTTLE_MS = 150; // Only update UI every 150ms max

            const config = {
                onUploadProgress: (progressEvent) => {
                    if (isCompleted) return;  // ← Skip all updates after completion
                    
                    const now = Date.now();
                    if (now - lastCallTime < THROTTLE_MS) return; // Throttle updates
                    lastCallTime = now;
       
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    if (percentCompleted === lastReportedPercent) return;
                    lastReportedPercent = percentCompleted;

                    file.progress = Math.min(percentCompleted, 99);
                    uploadProgressUpdate(file, percentCompleted);
                    onProgress({ uploadProgress: percentCompleted });
                }
            };

            promises.push(new Promise((resolve, reject) => {
                requestFilesServerPost("create_file", params, { 'Content-Type': 'multipart/form-data' }, (response) => {
                    isCompleted = true;  // ← Lock out any further progress updates
                    file.progress = 100;
                    uploadProgressUpdate(file, 100);
                    onProgress({ uploadProgress: 100 });
                    resolve();
                }, usertoken, config);
            }));
        });

        return Promise.all(promises);
    }

    // static handleFilesUpload = async (
    //     files,
    //     props,
    //     uploadProgressUpdate = () => { },
    //     onProgress = () => { },
    //     currentProgress = 0,
    //     accessbranchesOverride = null
    // ) => {

    //     const { requestServerPost, requestFilesServerPost, usertoken, selectedBrandData, selectedBranchData, selectedFolderID } = props;

    //     const promises = [];

    //     // 🔹 logic เดิม (เก็บไว้ครบ)
    //     const sharingMode = selectedBrandData ? selectedBrandData.ContentSharingMode : null;
    //     let createlevel = 1;
    //     let accessbranches = "all";

    //     if (sharingMode == 2) {
    //         const isBrandLevel = !selectedBranchData;
    //         createlevel = isBrandLevel ? 1 : 2;
    //         accessbranches = isBrandLevel ? "all" : selectedBranchData.BranchID;
    //     }

    //     if (accessbranchesOverride !== null) {
    //         accessbranches = accessbranchesOverride;
    //     }

    //     // 🔥 parallel upload (เร็วขึ้น)
    //     files.forEach((file) => {

    //         const promise = new Promise(async (resolve, reject) => {

    //             try {
    //                 file.progress = currentProgress;
    //                 uploadProgressUpdate(file);

    //                 // 1. ขอ presigned URL
    //                 requestServerPost(
    //                     "get_upload_url",
    //                     {
    //                         filename: file.name,
    //                         brandid: selectedBrandData.BrandID
    //                     },
    //                     {},
    //                     async (presignRes) => {
    //                         console.log("Presign response:", presignRes);
    //                         const { upload_url, file_key, filename } = presignRes.data;

    //                         // 2. upload เข้า DO Space
    //                         await new Promise((res, rej) => {

    //                             const xhr = new XMLHttpRequest();
    //                             xhr.open("PUT", upload_url);
    //                             xhr.setRequestHeader("x-amz-acl", "public-read");
                                
    //                             let lastPercent = -1;

    //                             xhr.upload.onprogress = (e) => {
    //                                 if (e.lengthComputable) {
    //                                     const percent = Math.round((e.loaded * 100) / e.total);

    //                                     // 🔹 กัน spam progress
    //                                     if (percent === lastPercent) return;
    //                                     lastPercent = percent;

    //                                     file.progress = percent;
    //                                     uploadProgressUpdate(file, percent);
    //                                     onProgress({ uploadProgress: percent });
    //                                 }
    //                             };

    //                             xhr.onload = () => {
    //                                 if (xhr.status === 200) res();
    //                                 else rej(xhr.responseText);
    //                             };

    //                             xhr.onerror = rej;

    //                             xhr.send(file);
    //                         });



    // //         params.append('file[]', file);
    // //         params.append('filetype', file.filetype);
    // //         params.append('brandid', selectedBrandData.BrandID);
    // //         params.append('fileproperties', JSON.stringify(file.properties));
    // //         params.append('folderparentid', selectedFolderID);
    // //         params.append('createlevel', createlevel);
    // //         params.append('accessbranches', accessbranches);
    
    //                         // 3. save DB (เหมือนเดิม)
    //                         requestFilesServerPost(
    //                             "save_file",
    //                             {
    //                                 filename: file.name,
    //                                 uploadfile: filename,
    //                                 file_key: file_key,
    //                                 fileproperties: JSON.stringify(file.properties),
    //                                 filetype: file.filetype,
    //                                 brandid: selectedBrandData.BrandID,
    //                                 folderparentid: selectedFolderID,
    //                                 createlevel,
    //                                 accessbranches
    //                             },
    //                             {},
    //                             (r2) => {

    //                                 file.progress = 100;
    //                                 uploadProgressUpdate(file, 100);

    //                                 resolve();
    //                             },
    //                             usertoken
    //                         );


    //                     },
    //                     usertoken
    //                 );



    //             } catch (err) {
    //                 console.error("Upload error:", err);
    //                 reject(err);
    //             }

    //         });

    //         promises.push(promise);
    //     });

    //     return Promise.all(promises);
    // };

    static createFolderFile = (folderName, parentid, props, accessbranchesOverride = null) => {
        return new Promise((resolve, reject) => {
            const { requestServerPost, usertoken, data = null, selectedBrandData, selectedBranchData } = props;

            // Determine create level and accessbranches based on ContentSharingMode
            const sharingMode = selectedBrandData ? selectedBrandData.ContentSharingMode : "1";
            let createlevel = 1;
            let accessbranches = "all";

            if (sharingMode == 2) {
                const isBrandLevel = !selectedBranchData;
                createlevel = isBrandLevel ? 1 : 2;
                accessbranches = isBrandLevel ? "all" : selectedBranchData.BranchID;
            }
            else {
                createlevel = 1;
                accessbranches = "all";
            }

            if (accessbranchesOverride !== null) {
                accessbranches = accessbranchesOverride;
            }

            var params = new FormData();
            params.append('foldername', folderName);
            params.append('folderparentid', parentid);
            params.append('brandid', selectedBrandData.BrandID);
            params.append('createlevel', createlevel);
            params.append('accessbranches', accessbranches);

            requestServerPost("create_folderfile", params, {}, (response) => {
                console.log("response " + JSON.stringify(response))
                resolve(response);
            }, usertoken);
        })
    }

    static extractFileProperties = (fileData) => {
        const { FileProperties = "{}" } = fileData;

        // console.log("typeof FileProperties " + typeof FileProperties)
        if (typeof FileProperties === "object") {
            return FileProperties ? FileProperties : {}
        }
        // console.log("FileProperties " + FileProperties)
        const FilePropertiesJSON = JSON.parse(((FileProperties == "") || !FileProperties) ? "{}" : FileProperties);
        return FilePropertiesJSON;
    }

    static getPlaylists = (params, props) => {
        const { usertoken, requestServerGet } = props
        return new Promise((resolve, reject) => {

            requestServerGet("get_playlists", params, null, (response) => {

                const prepairedData = response.data.map(pdata => {
                    if ("Medias" in pdata) {
                        pdata.Medias = pdata.Medias.map(mdata => {
                            return DataHelper.prepareFileData(mdata)
                        })
                    }
                    return pdata
                })

                resolve(prepairedData)
            }, usertoken)
        });
    }

    static publishContent = (screenDatas = [], callBack = () => { }, props) => {
        const { usertoken, requestServerPost } = props
        const screenIDs = screenDatas.map(sData => {
            return sData.ScreenID;
        })

        requestServerPost("publish_content", { screenids: screenIDs.join(",") }, {}, () => {

            screenDatas.forEach(sData => {
                const { AccountCode = "", BrandCode = "", BranchCode = "", ScreenCode = "" } = sData;
                const db = firebase.database().ref().child(`${AccountCode}/${BrandCode}/${BranchCode}/${ScreenCode}`);

                // console.log(roomId + " set " + key + " " + value );
                if (db) {
                    db.child("needs_download_content").set(0);
                    db.child("needs_download_content").set(1);
                }
            })

            callBack();
        }, usertoken)
    }

    static clearScreenUnpariRequest = (screenData) => {
        const { AccountCode = "", BrandCode = "", BranchCode = "", ScreenCode = "" } = screenData;
        const db = firebase.database().ref().child(`${AccountCode}/${BrandCode}/${BranchCode}/${ScreenCode}`);

        // console.log(roomId + " set " + key + " " + value );
        if (db) {
            db.child("needs_unpair").set(0);
        }
    }

    static getFileByMedia = (mediaData, props) => {
        const { usertoken, requestServerGet } = props

        const params = { fileid: mediaData.FileID }
        return new Promise((resolve, reject) => {
            requestServerGet("get_files", params, null, (response) => {
                // console.log("get_files" + JSON.stringify(response.data))


                const checkIsVideo = (fileName) => {
                    const videoExtensions = ["mp4", "avi", "mov"];
                    const ext = path.extname(fileName).toLocaleLowerCase().replace(".", "")

                    return videoExtensions.some((extName) => {
                        // console.log("asdasdasda")
                        // console.log(extName)
                        // console.log(ext)
                        // console.log(ext === extName.toLocaleLowerCase())

                        return ext === extName.toLocaleLowerCase()
                    });
                }

                const prepairedData = response.data.map(data => {
                    const type = checkIsVideo(data.UploadFile) ? "video" : "image"
                    data.type = type
                    return data
                })

                resolve(prepairedData)
            }, usertoken)
        });

        // var fileData = {};

        // fileData.FileID = 
        // fileData.FileName = 
        // fileData.UploadFile = 
        // fileData.BrandID = 
        // return fileData;
    }

    createPlaylistMediaFromDroppedFile = (dropResult, playlistID, brandID, props) => {
        return new Promise((resolve, reject) => {
            const { removedIndex, addedIndex, payload, element } = dropResult;

            if (payload && "groupName" in payload && payload.groupName === "file") {
                const { requestServerPost, usertoken, selectedBrandData, data = null } = props;
                var params = {};

                params["playlistid"] = playlistID;
                params["brandid"] = brandID;
                params["medianame"] = payload.FileName;
                params["startat"] = 0;
                params["duration"] = 30;
                params["fileid"] = payload.FileID;
                params["scale"] = DEFAULT_FFILE_SCALING;
                params["startdate"] = "";
                params["enddate"] = "";

                requestServerPost("create_media", params, {}, (response) => {
                    resolve(response.data)
                }, usertoken);
            }
        })
    }

}

export default DataHelper;